import React, { useEffect, useState } from "react"
import useCustomer from "../../hooks/data/useCustomer";
import { Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Wrapper = ({ children }: { children: React.ReactNode }) => {
    const [error, setError] = useState<string | undefined>();
    const [info, setInfo] = useState<string | undefined>();
    const {
        customers,
        isLoading
    } = useCustomer();

    const handleCloseError = () => {
        setError(undefined);
    }
    const handleCloseInfo = () => {
        setInfo(undefined);
    }

    useEffect(() => {
        if (!isLoading && customers.length > 1) {
            setError('Company Information error, please verify customers query access rights')
        }

        if (!isLoading && customers.length === 1) {
            setInfo(customers[0].webshoplogininfo);
        }

    }, [setError, isLoading, customers]);

    return (
        <>
            <Snackbar
                open={!!error}
                autoHideDuration={10000}
                onClose={handleCloseError}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseError} severity="warning" sx={{ width: '100%' }}>
                    {error}
                </Alert>
            </Snackbar>

            <Snackbar
                open={!!info}
                autoHideDuration={30000}
                onClose={handleCloseInfo}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={handleCloseInfo} severity="info" sx={{ width: '100%' }}>
                    {info}
                </Alert>
            </Snackbar>
            {children}
        </>
    )
}

export default Wrapper